import { bound } from "@frui.ts/helpers";
import type ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import { attachAutomaticValidator } from "@frui.ts/validation";
import { Modules } from "config";
import type UnpairedPayment from "entities/unpairedPayment";
import { computed } from "mobx";
import PaymentFilter, { PaymentFilterValidationRules } from "entities/filters/paymentFilter";
import type OptionsService from "services/optionsService";
import UnpairedPaymentStatus from "entities/unpairedPaymentStatus";
import ListViewModel from "../../listViewModel";
import { allowToPair } from "./rights";

export default abstract class UnpairedPaymentListViewModel<TDetail extends ScreenBase = ScreenBase> extends ListViewModel<
  UnpairedPayment,
  TDetail,
  ScreenBase,
  PaymentFilter
> {
  readonly modelName = "unpairedPayment";
  protected abstract optionsService: OptionsService;

  @computed
  get allowDelete() {
    return false;
  }

  @computed
  get allowToPair() {
    return allowToPair(this.securityService);
  }

  @computed
  get stateOptions() {
    return this.optionsService.internalEnumOptions(UnpairedPaymentStatus);
  }

  protected createFilter() {
    return attachAutomaticValidator(new PaymentFilter(), PaymentFilterValidationRules);
  }

  @bound
  stateName(state: UnpairedPaymentStatus) {
    return this.stateOptions.find(item => item.id === state)?.label;
  }

  protected fetchData() {
    const { limit, offset } = this.pagingFilter;
    return this.repository.getAllUnpairedPayments({ limit, offset }, this.appliedFilter);
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.finance, `paymentsPairing.${code}`, size);
  }
}
